export default __webpack_public_path__ + "static/14-48938bc3a3de46b9e87f147d8d16d162.jpg";